var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid"},[_c('welcome-message',{attrs:{"update-message":!_vm.user.is_user}}),_c('admin-dashboard',{attrs:{"chart-data":_vm.chartData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }